var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLikeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 12.6667H9.33342C8.41294 12.6667 7.66675 13.4129 7.66675 14.3333V21.8333C7.66675 22.7538 8.41294 23.5 9.33342 23.5H11.0001C11.9206 23.5 12.6668 22.7538 12.6668 21.8333V14.3333C12.6668 13.4129 11.9206 12.6667 11.0001 12.6667Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2308 23.5H16.176C15.5179 23.5 14.8746 23.3052 14.327 22.9402L13.0378 22.0807C12.806 21.9262 12.6668 21.666 12.6668 21.3873V14.5546C12.6668 14.4096 12.7046 14.2671 12.7765 14.1412L16.0001 8.5H17.1073C18.7713 8.5 19.7638 10.3545 18.8408 11.739L17.6668 13.5H22.1988C23.2831 13.5 24.0787 14.519 23.8157 15.5709L22.4646 20.9751C22.0937 22.459 20.7604 23.5 19.2308 23.5Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLikeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/likeIcon.12eab7d2ba945c2349903e4a780fd865.svg";